module.exports = __webpack_public_path__ + "img/INS.97f95cee.svg";